import { render, staticRenderFns } from "./TableColumnDate.vue?vue&type=template&id=b37d16e8&"
import script from "./TableColumnDate.vue?vue&type=script&lang=js&"
export * from "./TableColumnDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports